<template>
  <cTable
    style="height: calc(100vh - 200px)"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/b2borderStatistics";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      {
        type: "checkbox",
        width: 50,
        align: "center"
      },
      ...this.headers
    );
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          return apis[this.name](p);
        },
        beforeHandleList: ({ data }) => {
          return data;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("详情,导出"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("时间"),
          key: "time",
          minWidth: 130
        },
        {
          name: () => this.$tz("票数"),
          key: "num",
          minWidth: 130
        },
        {
          name: () => this.$tz("票数,比例"),
          key: "num_rate",
          minWidth: 130
        },
        {
          name: () => this.$tz("重量"),
          key: "weight",
          minWidth: 130
        },
        {
          name: () => this.$tz("重量,比例"),
          key: "weight_rate",
          minWidth: 130
        },
        {
          name: () => this.$tz("方数"),
          key: "volume",
          minWidth: 130
        },
        {
          name: () => this.$tz("方数,比例"),
          key: "volume_rate",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
